import axiosInstance from './axiosInstance';

export const resetOrderTimer = async (target: { userId: number } | { orderId: number }) => {
    const response = await axiosInstance.post('admin/protected/resetOrderTimer', target);
    // The shared interceptor resolves HTTP 400 responses, so a resolved request
    // does not necessarily mean the reset succeeded.
    if (response.status !== 200) {
        throw new Error(response.data?.message || '重置计时器失败');
    }
    return response.data;
};
